module.exports = __webpack_public_path__ + "static/target-529ba4c6483343cb2507944197f81bee.png";